import React from 'react';
import { SearchBarOrderSearch } from './SearchBarOrderSearch';

export interface ISearchBarOrderGroupProps {
  groupName: string;
  currentSearch: string;
  nothingMessage: string;
  emptyFilterMessage: string;
  fileNumberList: string[];
  setFileNumberList: (x: string[]) => void;
}

export const SearchBarOrderGroup: React.FC<ISearchBarOrderGroupProps> = ({
  groupName,
  currentSearch,
  nothingMessage,
  emptyFilterMessage,
  fileNumberList,
  setFileNumberList,
}) => {
  const ordersToShow = fileNumberList.slice(0, 10).filter((t) => (currentSearch ? t.endsWith(currentSearch) : true));

  return (
    <div>
      <SearchBarOrderSearch
        currentSearch={ordersToShow}
        title={groupName}
        emptyMessage={fileNumberList.length === 0 ? nothingMessage : emptyFilterMessage}
        remove={(fileNumber) => setFileNumberList(fileNumberList.filter((t) => t !== fileNumber))}
        clear={() => setFileNumberList([])}
      />
    </div>
  );
};
